const labelUserFormats = [
  { display: "Full name", format: "firstName lastName" },
  { display: "First name only", format: "firstName" },
  { display: "Last name only", format: "lastName" },
  { display: "First name & last initial", format: "firstName lastInitial" },
  { display: "Initials", format: "initial" },
]
export { labelUserFormats }
